import UsuarioNovo from './UsuarioNovo';

export default UsuarioNovo;